ajaxifyCollection = function(isSearch){
	//code borrowed from https://github.com/Elkfox/Ajaxify
	var linkParent = '.pagination'; // Class of pagination container
	var parentContainer = 'body'; // All of the content selector used to detect scroll bottom distance
	var endlessScrollContainer = '.EndlessScroll'; // Selector for endless scroll pages
	var endlessOffset = 300; // Offset the distance from the bottom of the page
	var ajaxinateContainer = '.Ajaxinate'; // ID Selector for ajax pagination pages
	var ajaxinateLink = '.pagination-next'; // Class Selector for ajax pagination links
	var fade = 'fast'; // fade speed
    var textChange = 'Loading'; // Text whilst loading content
    var loader = '.loader';

	var linkElem;
	var contentContainer;
	var pageNumber;
	var pageType;
	var action;
	var moreURL;
	var moreURLCheck;
	var currentPage;

	var maxPages = $('.pagination').data('pages');

	var loadedLastPage = false;
	var isLoading = false;

	$.loadMore = function() {
		// Handle both traditional page= and phcursor pagination
		if(isSearch && moreURL !== undefined) {
			if(moreURL.indexOf("page=") > -1) {
				moreURLCheck = moreURL.substring(moreURL.lastIndexOf("?page=")+1,moreURL.lastIndexOf("&q="));
				moreURLCheck = moreURLCheck.split("page=");
				currentPage = moreURLCheck[1];
			} else {
				currentPage = 2; // Default for cursor-based pagination
			}
		}
		else if (isSearch != true && moreURL !== undefined) {
			if(moreURL.indexOf("page=") > -1) {
				moreURLCheck = moreURL.split("page=");
				currentPage = moreURLCheck[1];
			} else if(moreURL.indexOf("phcursor") > -1) {
				// For cursor-based pagination, we can't determine exact page but we know there's more
				currentPage = 2; // Assume next page exists
			} else {
				currentPage = null;
			}
		}
		else {
			currentPage = null;
		}

	   if (moreURL && moreURL.length && loadedLastPage == false && !isLoading){
           isLoading = true;
           $(linkParent).css('opacity', 0);
           
           $(loader).show();

		 $.ajax({
		   type: 'GET',
		   dataType: 'html',
		   url: moreURL,
		   success: function(data) {
			console.log('Loading more products from:', moreURL);
			
			var $data = $(data);
			var filteredData = $data.find(contentContainer);
			
			if(filteredData.length > 0) {
				var filteredDataProducts = filteredData.html();
				var newProdHtml = $(filteredDataProducts);
				
				if(newProdHtml.length > 0) {
					$(contentContainer).append(newProdHtml);
					console.log('Added', newProdHtml.length, 'new products');
					
					var newProducts = newProdHtml;
					collectionGetVariations(newProducts);
				} else {
					console.log('No new products found');
					loadedLastPage = true;
				}
			} else {
				console.log('No content container found');
				loadedLastPage = true;
			}
            
            // Check for next page link
            var nextPageLink = $data.find(".pagination .pagination-next").attr('href');
            if(nextPageLink) {
            	moreURL = nextPageLink;
            	$(".pagination").html($data.find(".pagination").html());
            } else {
            	console.log('No more pages');
            	loadedLastPage = true;
            }

            // Check if we've reached max pages (for traditional pagination)
			if(currentPage == maxPages) {
				loadedLastPage = true;
			}
            
            // SPR.registerCallbacks();
            // SPR.initRatingHandler();
            // SPR.initDomEls();
            // SPR.loadProducts();
            // SPR.loadBadges();


			//  $(".swatch").click(function(){
		 	// 	var swatchName = $(this).attr('class').split(' ')[1];
		 	// 	var colorName = swatchName.replace('swatch-', '');
		 	// 	var currentSwatch = '.' + $(this).attr('class').split(' ')[1];
		 	// 	var findImage = '.image-' + colorName;

		 	// 	$(this).closest(".product").find(".product-image-swatch").css("z-index", "-1");

		 	// 	$(this).closest(".product").find(findImage).css("z-index", "2");
		 	// });

             $(linkParent).css('opacity', 0);
             
			 $(loader).hide();
			 isLoading = false;
			 if (pageType == 'endlessScroll') {
			   $.endlessScroll();
			 }
		   },
    		timeout:15000,
			error: function(jqXHR, textStatus, errorThrown) {
				$(loader).hide();
				isLoading = false;
		        if(textStatus === "timeout") {
					$(linkElem).text("Load more");
					$(linkElem).css('opacity', 1);
		        }
		        if (pageType == 'endlessScroll') {
		           $.endlessScroll();
		        }
		    }
		 });
	   }
	 };


	 $.endlessScroll = function() {
	  var scrollTimer;
	  action = 'scroll.endlessScroll load.endlessScroll resize.endlessScroll';
	  
	  $(window).on( action, function() {
		// Throttle scroll events for better performance
		clearTimeout(scrollTimer);
		scrollTimer = setTimeout(function() {
			contentContainer = endlessScrollContainer;
	        moreURL = $(linkElem).last().attr('href');

			pageType = 'endlessScroll';
			$(linkElem).text(textChange);

			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var documentHeight = $(document).height();
			var scrollBottom = scrollTop + windowHeight;

			if ($(contentContainer+':last-of-type '+linkElem).length || $(contentContainer).length >= 1){
				if($(contentContainer).length >= 1) {
					moreURL = $(linkElem).last().attr('href');
				}

			  // Check if we're near the bottom of the page
			  if( scrollBottom >= (documentHeight - endlessOffset) && moreURL && !loadedLastPage && !isLoading ) {
				console.log('Triggering load more - scrollBottom:', scrollBottom, 'documentHeight:', documentHeight, 'moreURL:', moreURL);
				$(window).off(action);
				  $.loadMore();
			  }
			}
		}, 100); // 100ms throttle
	  });
	};

	if ( $( endlessScrollContainer ).length ) {
      linkElem = linkParent + ' ' + ajaxinateLink;
	  $.endlessScroll();
	}
};
